import axios from 'axios';
import { ApiEndpoints } from './urls';
import { drfQueryParams } from './utils';

class CommentsApi {
  // ------ Action Type API ------
  static getAllComments(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.commentList, { params });
  }

  static getComment({ id }) {
    return axios.get(ApiEndpoints.comment.replace(':id:', id));
  }

  static deleteComment({ id }) {
    return axios.delete(ApiEndpoints.comment.replace(':id:', id));
  }

  static addComment(params) {
    return axios.post(ApiEndpoints.commentList, params);
  }

  static updateComment(props) {
    const { id, ...rest } = props;
    return axios.patch(ApiEndpoints.comment.replace(':id:', id), { ...rest });
  }

  static getAllCommentThemes(props) {
    const {
      page, pageSize, filters, sorted
    } = props;
    const params = drfQueryParams(page, pageSize, filters, sorted, false);
    return axios.get(ApiEndpoints.commentThemeList, { params });
  }

  static getCommentTheme({ id }) {
    return axios.get(ApiEndpoints.commentTheme.replace(':id:', id));
  }
}

export default CommentsApi;
